module.exports = __webpack_public_path__ + "static/media/logo-name.13754832.svg";